(function () {
  function shade(hex, pct) {
    hex = String(hex || '#16161a').replace('#', '');
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    var r = parseInt(hex.slice(0, 2), 16),
      g = parseInt(hex.slice(2, 4), 16),
      b = parseInt(hex.slice(4, 6), 16);
    if (isNaN(r) || isNaN(g) || isNaN(b)) return '#' + hex;
    function adj(c) {
      var v = pct >= 0 ? c + (255 - c) * pct : c * (1 + pct);
      return Math.max(0, Math.min(255, Math.round(v)));
    }
    function hx(c) { return ('0' + c.toString(16)).slice(-2); }
    return '#' + hx(adj(r)) + hx(adj(g)) + hx(adj(b));
  }

  function boldify(str) {
    // turns **word** into <b>word</b> for toast messages
    return String(str || '').replace(/\*\*(.+?)\*\*/g, '<b>$1</b>');
  }

  function initSection(cfg) {
    var id = cfg.id;
    var root = document.getElementById('sw-wheel-' + id);
    var sectionRoot = document.getElementById('sw-' + id);
    if (!root || !sectionRoot) return;

    var segs = (cfg.segments || []).filter(function (s) { return s && s.label; });
    var N = segs.length;
    if (!N) return;

    var step = 360 / N;
    var START = 0;
    var R = 140, cx = 150, cy = 150;
    var RAD = Math.PI / 180;

    function pt(ang, r) {
      return [cx + r * Math.sin(ang * RAD), cy - r * Math.cos(ang * RAD)];
    }

    var segG = document.getElementById('sw-segs-' + id);
    var labG = document.getElementById('sw-labels-' + id);

    if (segG && labG) {
      var defs = '', paths = '';
      for (var i = 0; i < N; i++) {
        var a0 = i * step - step / 2 + START;
        var a1 = a0 + step;
        var p0 = pt(a0, R);
        var p1 = pt(a1, R);
        var base = segs[i].fill || '#16161a';
        var gid = 'swSeg-' + id + '-' + i;
        defs += '<linearGradient id="' + gid + '" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="' + shade(base, 0.12) + '"/>' +
          '<stop offset="100%" stop-color="' + shade(base, -0.55) + '"/></linearGradient>';
        paths += '<path d="M' + cx + ' ' + cy +
          ' L' + p0[0].toFixed(2) + ' ' + p0[1].toFixed(2) +
          ' A' + R + ' ' + R + ' 0 0 1 ' + p1[0].toFixed(2) + ' ' + p1[1].toFixed(2) +
          ' Z" fill="url(#' + gid + ')"/>';
      }
      segG.innerHTML = '<defs>' + defs + '</defs>' + paths;

      var rLabel = 101, BASE = 12, labelsHtml = '';
      for (var j = 0; j < N; j++) {
        var mid = (j * step + START) % 360;
        var lp = pt(mid, rLabel);
        var label = segs[j].label || '';
        var col = segs[j].textColor || '#ffffff';
        labelsHtml += '<text x="' + lp[0].toFixed(2) + '" y="' + lp[1].toFixed(2) +
          '" font-size="' + BASE + '" fill="' + col +
          '" transform="rotate(' + mid.toFixed(1) + ' ' + lp[0].toFixed(2) + ' ' + lp[1].toFixed(2) + ')"' +
          ' dominant-baseline="central">' + label + '</text>';
      }
      labG.innerHTML = labelsHtml;

      var maxW = rLabel * ((step * Math.PI) / 180) * 0.86;
      var texts = labG.querySelectorAll('text');
      for (var k = 0; k < texts.length; k++) {
        var el = texts[k], len = 0;
        try { len = el.getComputedTextLength(); } catch (e) {}
        if (!len) len = (el.textContent.length || 0) * BASE * 0.62;
        if (len > maxW) {
          var f = (BASE * maxW) / len;
          el.setAttribute('font-size', (f < 5 ? 5 : f).toFixed(2));
        }
      }
    }

    var bulbs = document.getElementById('sw-bulbs-' + id);
    if (bulbs) {
      var b = '', DUR = [1.2, 1.5, 1.8, 2.1];
      for (var m = 0; m < 24; m++) {
        var deg = m * 15, rr = 47;
        var bx = 50 + rr * Math.sin(deg * RAD);
        var by = 50 - rr * Math.cos(deg * RAD);
        b += '<span style="left:' + bx.toFixed(2) + '%;top:' + by.toFixed(2) + '%;' +
          'animation-duration:' + DUR[m % 4] + 's;animation-delay:' + (m * 0.08).toFixed(2) + 's;"></span>';
      }
      bulbs.innerHTML = b;
    }

    var toastEl = document.getElementById('sw-toast-' + id);
    var toastTimer;
    function showToast(html) {
      if (!toastEl) return;
      toastEl.innerHTML = html;
      toastEl.classList.add('show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toastEl.classList.remove('show');
      }, 2600);
    }

    var disc = document.getElementById('sw-disc-' + id);
    var spinBtn = document.getElementById('sw-spin-' + id);
    var turns = 0, spinning = false;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function demoSpin() {
      if (spinning || !disc) return;
      if (reduceMotion) {
        showToast(boldify(cfg.toastMessage));
        return;
      }
      spinning = true;
      if (spinBtn) spinBtn.disabled = true;
      turns += 5 + Math.floor(Math.random() * 3);
      var seg = Math.floor(Math.random() * N);
      var landing = (360 - seg * step) % 360;
      disc.style.transform = 'rotate(' + (turns * 360 + landing) + 'deg)';
      setTimeout(function () {
        spinning = false;
        if (spinBtn) spinBtn.disabled = false;
        showToast(boldify(cfg.toastMessage));
      }, 4600);
    }

    if (spinBtn) spinBtn.addEventListener('click', demoSpin);

    var liveEl = sectionRoot.querySelector('.sw-live-count');
    if (liveEl) {
      var base = parseInt(liveEl.getAttribute('data-base'), 10) || parseInt(liveEl.textContent, 10) || 5000;
      var lo = base - 300, hi = base + 300, v = base;
      liveEl.textContent = v.toLocaleString();
      setInterval(function () {
        v += Math.floor(Math.random() * 7) - 3;
        if (v < lo) v = lo;
        if (v > hi) v = hi;
        liveEl.textContent = v.toLocaleString();
      }, 3200);
    }

    var cta = sectionRoot.querySelector('[data-sw-scroll]');
    if (cta) {
      cta.addEventListener('click', function () {
        var sel = cta.getAttribute('data-sw-scroll');
        var target = sel ? document.querySelector(sel) : null;
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function init() {
    (window.swSections || []).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();